export const pptTheme = {
  primary: "2563EB",
  text: "101828",
  muted: "64748B",
  light: "F3F4F6",
  white: "FFFFFF"
};